module.exports = __webpack_public_path__ + "img/IASA.c5922ee3.png";